import styled, { css } from 'styled-components';
import { zIndexDialogBackdrop } from "../../styles";
export var OverlayBackdrop = styled.div.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "OverlayBackdrop",
  componentId: "jy08vf-0"
})(["background-color:rgba(0,0,0,0.4);height:100%;left:0;position:fixed;top:0;width:100%;z-index:", ";", ";"], zIndexDialogBackdrop, function (props) {
  return props.center && css(["align-items:center;display:flex;justify-content:center;"]);
});